<div class="search-result-listing">
  @for (_ of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
    <div class="skeleton-tile-wrapper">
      <mat-card class="search-result-tile skeleton-tile">
        <mat-card-header class="search-result-tile-header">
          <mat-card-title class="search-result-tile-title">
            <div class="skeleton skeleton-type"></div>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content class="search-result-tile-content">
          <div class="custom-image">
            <div class="skeleton skeleton-icon"></div>
          </div>

          <div class="title">
            <div class="skeleton skeleton-title"></div>
          </div>

          <div class="metadata">
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line short"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
